module.exports = __webpack_public_path__ + "images/bd66eedc02c1a8124e7b23aa0d62fbc2.svg";